import React from 'react'

import { ReactComponent as NestedProjectIcon } from '@sketch/icons/folder-closed-17'

// This component shares the same util as ProjectItem
import { getButtonProps } from '../../../shares/components/ProjectItem/utils'

import { HighlightedText, TableComponents, Skeleton } from '@sketch/components'

import { useNestedProjectDropShares } from '../../hooks'

// This component shares styles with DocumentItem
import {
  ImageWrapper,
  Name,
  StatusIcon,
  TableCell,
  TableWrapper,
  NameWrapper,
  DroppableTableWrapper,
  DroppableTableWrapperDragTooltip,
} from '../../../shares/components/DocumentItem/DocumentItem.styles'

import { NestedProjectItemProps } from './types'
import { PreviewSubtitle } from './PreviewSubtitle'
import { useSearch } from '@sketch/utils'
import { useFolderTerm } from '@sketch/modules-common'
import { isNestedProject } from '../../../shares/components/ShareActionsDropdown'

export const NestedProjectItemListView = (props: NestedProjectItemProps) => {
  const {
    className,
    nestedProject,
    onClick,
    workspaceIdentifier,
    renderDropdown,
    disabledDrag,
  } = props

  const {
    isDraggedOver = false,
    isDraggedOverItself = false,
    isDroppableAreaEnabled,
    ...dragAndDropEvents
  } = useNestedProjectDropShares({
    projectIdentifier: nestedProject.identifier,
    workspaceId: workspaceIdentifier,
    disabled: disabledDrag,
  })

  const a11yProps = onClick ? getButtonProps(onClick) : {}
  const dropdownContent = renderDropdown?.()
  const { search } = useSearch()

  const isDroppable =
    isDroppableAreaEnabled && isDraggedOver && !isDraggedOverItself

  if (!isNestedProject(nestedProject)) return null

  return (
    <DroppableTableWrapper
      $isDraggedOver={isDroppable}
      className={className}
      title={nestedProject.name}
      {...dragAndDropEvents}
      {...a11yProps}
    >
      <TableCell>
        {isDroppable && (
          <DroppableTableWrapperDragTooltip>
            Add to folder
          </DroppableTableWrapperDragTooltip>
        )}
        <NameWrapper>
          <ImageWrapper title={nestedProject.name}>
            <StatusIcon
              as={NestedProjectIcon}
              aria-label={`Folder ${nestedProject.name}`}
            />
          </ImageWrapper>
          <Name>
            <HighlightedText search={search}>
              {nestedProject.name}
            </HighlightedText>
          </Name>
        </NameWrapper>
      </TableCell>
      <TableCell>
        <PreviewSubtitle
          nestedProjectsCount={nestedProject.nestedProjectsCount}
          sharesCount={nestedProject.sharesCount}
        />
      </TableCell>
      <TableComponents.TableCellSticky>
        {dropdownContent}
      </TableComponents.TableCellSticky>
    </DroppableTableWrapper>
  )
}

export interface NestedProjectItemListViewSkeletonProps {
  inViewListener?: React.ReactNode
}
export const NestedProjectItemListViewSkeleton = (
  props: NestedProjectItemListViewSkeletonProps
) => {
  const { inViewListener } = props
  const folderTerm = useFolderTerm()

  return (
    <TableWrapper>
      <TableCell>
        <NameWrapper>
          <ImageWrapper>
            <StatusIcon as={NestedProjectIcon} aria-label={folderTerm.upper} />
          </ImageWrapper>
          <Skeleton height="12px" width="30%" />
        </NameWrapper>
      </TableCell>
      <TableCell>
        <Skeleton height="12px" width="30%" />
        {inViewListener}
      </TableCell>
      <TableCell></TableCell>
    </TableWrapper>
  )
}
